import { render, staticRenderFns } from "./tabsView.vue?vue&type=template&id=c6d1bdfc&scoped=true&"
import script from "./tabsView.vue?vue&type=script&lang=js&"
export * from "./tabsView.vue?vue&type=script&lang=js&"
import style0 from "./tabsView.vue?vue&type=style&index=0&id=c6d1bdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d1bdfc",
  null
  
)

export default component.exports